import styled from 'styled-components';

export const MobileBarWrapper = styled.div`
    height: 56px;
    display: flex;
    width: 100vw;
`;
